import styled from "styled-components";
import { Box } from "@mui/material";

export const CheckoutDrawerPaper = styled(Box)`
	border-radius: 20px 20px 0 0;
	padding: 24px 24px 28px;
	max-width: 480px;
	width: -webkit-fill-available;
	margin: 0 auto;
`;

export const CheckoutRow = styled(Box)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 16px;
`;

export const DiscountChip = styled(Box)`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 13px;
	font-weight: 600;
	color: #2e7d32;
	background: #e8f5e9;
	border-radius: 20px;
	padding: 4px 12px;
	margin-top: 12px;
	width: fit-content;
`;

export const TotalRow = styled(Box)`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const CouponRow = styled(Box)`
	display: flex;
	gap: 10px;
	align-items: center;
`;
